import { InjectionToken } from '@angular/core';

export interface StrapiCmsConfig {
  apiUrl: string;
}

/** Creates a document module configuration injection token */
export const STRAPI_CMS_CONFIG = new InjectionToken<StrapiCmsConfig>('StrapiCmsConfig');
